document.addEventListener('DOMContentLoaded', () => {
  const heroLinkEls = document.querySelectorAll('[data-hero-link]');
  heroLinkEls.forEach(link => {
    link.addEventListener('click', (e) => {
      const targetId = link.getAttribute('href');
      const targetElement = document.querySelector(targetId);
      if (targetElement) {
        targetElement.focus();
        const targetElementFlickityEl = targetElement.closest('[data-flickity-flex]');
        if (targetElementFlickityEl) {
          const flickityInstance = Flickity.data(targetElementFlickityEl);
          if (flickityInstance) {
            flickityInstance.selectCell(targetElement);
          }
        }
      }
    });
  });

  const scrollContainer = document.querySelector('[data-scroll-element]');
  const prefersReducedMotionMQ = window.matchMedia('(prefers-reduced-motion: reduce)');
  const mediaQuery = window.matchMedia('(max-width:1200px)');

  const initAnimation = () => {
    if (scrollContainer && !prefersReducedMotionMQ.matches && mediaQuery.matches) {
      // Define the object to animate
      const scrollObject = {
        scrollValue: 0
      };
      
      const scrollAnimation = anime({
        targets: scrollObject,
        scrollValue: scrollContainer.scrollWidth - scrollContainer.clientWidth,
        duration: 20000,
        easing: 'linear',
        direction: 'alternate',
        loop: true,
        // Update the scrollLeft property on each animation frame
        update: (anim) => {
          scrollContainer.scrollLeft = anim.animatables[0].target.scrollValue;
        },
      });
    
      const stopAnimation = () => anime.remove(scrollObject);
      const pauseAnimation = () => scrollAnimation.pause();
      const playAnimation = () => scrollAnimation.play();
    
      scrollContainer.addEventListener('mouseenter', pauseAnimation);
      scrollContainer.addEventListener('mouseleave', playAnimation);
      scrollContainer.addEventListener('touchstart', stopAnimation);
      scrollContainer.addEventListener('touchend', stopAnimation);
    }
  };

  mediaQuery.addEventListener('change', (e) => {
    if (e.matches) {
      initAnimation();
    }
  });
  initAnimation();
});